<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-listContain`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.8701 11.7383C13.2374 11.7383 13.5352 12.0361 13.5352 12.4033C13.5352 12.7706 13.2374 13.0684 12.8701 13.0684H3.12988C2.76266 13.0683 2.46484 12.7706 2.46484 12.4033C2.46484 12.0361 2.76266 11.7383 3.12988 11.7383H12.8701ZM12.8701 9.90625C13.2374 9.90625 13.5352 10.204 13.5352 10.5713C13.5352 10.9386 13.2374 11.2363 12.8701 11.2363H3.12988C2.76266 11.2363 2.46484 10.9385 2.46484 10.5713C2.46484 10.2041 2.76266 9.9063 3.12988 9.90625H12.8701ZM10.5215 2.92188C12.1858 2.92188 13.5352 4.2712 13.5352 5.93555C13.5351 7.59987 12.1858 8.94922 10.5215 8.94922H3.12988C2.7627 8.94917 2.46491 8.65136 2.46484 8.28418C2.46484 7.91694 2.76266 7.61919 3.12988 7.61914H10.5215C11.4513 7.61914 12.205 6.86533 12.2051 5.93555C12.2051 5.00574 11.4513 4.25195 10.5215 4.25195H3.12988C2.76266 4.2519 2.46484 3.95415 2.46484 3.58691C2.46484 3.21968 2.76266 2.92192 3.12988 2.92188H10.5215Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineListContain',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
